import React, { useEffect, useState } from 'react';
import Tooltip from '@src/components/Tooltip';
import { NAME_REGEX } from '@src/constants/project';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { StyledEditNameBlock } from './index.style';

const EditNameBlock = ({ blockId, title, index }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const { getFeatureValue } = useFeatureFlags();
  const [name, setName] = useState(title);
  const [error, setError] = useState('');

  const slideV2Enabled = getFeatureValue(FEATURE_KEYS.PRESENTATION_SLIDE_V2, {
    userId: user?.id,
    email: user?.email,
    phoneNumber: user?.phoneNumber,
  });

  const placeholder = slideV2Enabled
    ? t('presentationBlockTitle', { index })
    : t('nameDefaultBlock');

  const validateName = (value) => {
    if (!value || value.length < 1 || value.length > 30) {
      return t('msgErrorEditNameBlockMinLength');
    }
    if (!NAME_REGEX.test(value)) {
      return t('msgErrorEditNameBlockMaxSymbol');
    }
    return '';
  };

  useEffect(() => {
    setName(title);
  }, [title]);

  const handleChangeName = (e) => {
    const { value } = e.target;
    setName(value);
    setError(validateName(value));
  };

  const handleBlurName = () => {
    if (error) {
      setName(title);
      setError('');
    } else {
      dispatch(actions.project.updateBlock(blockId, { title: name?.trim() }));
      setName(name?.trim());
    }
  };

  return (
    <>
      <StyledEditNameBlock
        isError={!!error}
        onBlur={handleBlurName}
        onChange={handleChangeName}
        value={name}
        type="text"
        maxLength={255}
        autoComplete="off"
        placeholder={placeholder}
        spellCheck={false}
      />

      {error && (
        <Tooltip arrow title={error} placement="top">
          <InfoRoundedIcon
            sx={{
              color: COLOR.textRejected,
              fontSize: 16,
              marginRight: '4px',
            }}
          />
        </Tooltip>
      )}
    </>
  );
};

export default EditNameBlock;
